import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSidebarRightHide20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.5 4.5h-9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9zm6.5 1A2.5 2.5 0 0 0 16.5 3h-13A2.5 2.5 0 0 0 1 5.5v9A2.5 2.5 0 0 0 3.5 17h13a2.5 2.5 0 0 0 2.5-2.5zM6.063 8.06A.75.75 0 0 1 7.124 7L9.6 9.475l.53.53-.53.53-2.475 2.475a.75.75 0 1 1-1.06-1.06l1.944-1.945z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide20Filled);
